@import '~/variables.module.css';

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: row;

  &.vertical {
    flex-direction: column;
  }

  &:not(.disabledInput) {
    cursor: pointer;
  }
}

.label-text {
  user-select: none;
}

.input {
  appearance: none;
  background-repeat: no-repeat;
  background-size: contain;

  &:not(:disabled) {
    cursor: pointer;
  }

  &:focus,
  &:active {
    outline: none;
  }
}

.switch {
  height: 20px;
  width: 36px;
  margin: 0;
  background-image: url('/icons/switch-off.svg');

  &:checked {
    background-image: url('/icons/switch-on.svg');
  }

  &::after {
    content: url('/icons/switch-off.svg') url('/icons/switch-on.svg');
  }
}

.checkbox {
  height: 24px;
  width: 24px;
  min-width: 24px;
  background-image: url('/icons/checkbox-unchecked.svg');

  &:checked {
    background-image: url('/icons/checkbox-checked.svg');
  }

  &::after {
    content: url('/icons/checkbox-unchecked.svg') url('/icons/checkbox-checked.svg');
  }
}

.radio {
  height: 16px;
  width: 16px;
  background-image: url('/icons/radio-off.svg');

  &:checked {
    background-image: url('/icons/radio-on.svg');
  }

  &::after {
    content: url('/icons/radio-off.svg') url('/icons/radio-on.svg');
  }
}

.round-check {
  height: 16px;
  width: 16px;
  margin: 0;
  background-image: url('/icons/round-check-off.svg');

  /* TODO seems weird we don't just check for hover via css too / instead, should look into it more */
  &.hovered:not(:checked)/*, &:hover:not(:checked)*/ {
    background-image: url('/icons/round-check-off-hover.svg');
  }

  &:checked {
    background-image: url('/icons/round-check-checked.svg');
  }

  &::after {
    content: url('/icons/round-check-off.svg')
      url('/icons/round-check-off-hover.svg') url('/icons/round-check-checked.svg');
  }
}

.check-when-selected {
  margin: 0;

  &:not(:checked) {
    display: none;
  }

  &:checked {
    height: 16px;
    width: 16px;
    background-image: url('/icons/checkmark-blue-lighter.svg');
  }

  &::after {
    content: url('/icons/checkmark-blue-lighter.svg');
  }
}

.none {
  display: none;
}

.switch::after,
.checkbox::after,
.radio::after,
.round-check::after,
.check-when-selected::after {
  @mixin background-image-preloading;
}
